@let asyncContext = { period: period$ | async };
<ui-section
    [title]="config.translations.widgetTitle"
    [subtitle]="
        asyncContext.period === lastTwelveMonths
            ? ('WIDGET.PERIOD_TWELVE_MONTHS' | translate)
            : asyncContext.period
              ? ('WIDGET.PERIOD_YEAR' | translate: { year: asyncContext.period | translatePeriod })
              : ''
    "
>
    @let dataSource = dataSource$ | async;
    <ui-section-actions>
        @if (dataSource?.length > 0) {
            <ui-icon-button
                color="primary"
                iconName="export-spreadsheet"
                class="no-print"
                [advizeoTooltip]="'CSV_EXPORT.MOUSEHOVER' | translate"
                (click)="exportDataAsCsv()"
            />

            <button
                ui-button
                color="primary"
                iconName="go-to"
                buttonStyle="outline"
                size="small"
                class="no-print"
                (click)="goToBillsByBuilding()"
            >
                {{ 'WIDGET.WATCH_BALANCE' | translate }}
            </button>
        }
    </ui-section-actions>
    <ui-section-content>
        <developer-helper [datasourceCode]="developerHelperDataSourceCode" />
        @if (dataSource?.length > 0 && !isLoading && !loadingError) {
            <ui-table class="width-100" [dataSource]="dataSource">
                <!-- type Column (universe icon) -->
                <ng-container uiColumnDef="type" size="0.5">
                    <ui-header-cell *uiHeaderCellDef />
                    <ui-cell *uiCellDef="let universeData; let i = index">
                        @if (universeData.universeId) {
                            <ui-avatar shape="circle" size="small" [src]="universeData.universeId | universeImage" />
                        }
                    </ui-cell>
                </ng-container>
                <!-- universe Column -->
                <ng-container uiColumnDef="universe">
                    <ui-header-cell *uiHeaderCellDef>{{ 'WIDGET.ENERGY_BALANCE_TABLE.UNIVERSE' | translate }}</ui-header-cell>
                    <ui-cell *uiCellDef="let universeData; let i = index">
                        @if (!universeData.isTotal) {
                            <span>{{ universeData.universeId | referenceListLabel: 'universe' }}</span>
                        } @else {
                            <span class="text-strong">
                                {{ 'WIDGET.ENERGY_BALANCE_TABLE.TOTAL' | translate }}
                            </span>
                        }
                    </ui-cell>
                </ng-container>
                <!-- actualConsumption Column -->
                <ng-container uiColumnDef="actualConsumption">
                    <ui-header-cell *uiHeaderCellDef>{{ 'WIDGET.ENERGY_BALANCE_TABLE.ACTUAL_CONSUMPTION' | translate }}</ui-header-cell>
                    <ui-cell *uiCellDef="let rowData; let i = index" [class.text-strong]="rowData.isTotal">
                        {{ rowData.measured | formatUnit: valueFormatter }}
                    </ui-cell>
                </ng-container>
                <!-- estimatedConsumption Column -->
                <ng-container uiColumnDef="estimatedConsumption">
                    <ui-header-cell *uiHeaderCellDef>
                        {{ 'WIDGET.ENERGY_BALANCE_TABLE.ESTIMATED_CONSUMPTION' | translate }}
                    </ui-header-cell>
                    <ui-cell *uiCellDef="let rowData; let i = index" [class.text-strong]="rowData.isTotal">
                        {{ rowData.estimated | formatUnit: valueFormatter }}
                    </ui-cell>
                </ng-container>
                <!-- referenceGap Column -->
                <ng-container uiColumnDef="referenceGap">
                    <ui-header-cell *uiHeaderCellDef>{{ 'WIDGET.ENERGY_BALANCE_TABLE.REFERENCE_GAP' | translate }}</ui-header-cell>
                    <ui-cell *uiCellDef="let rowData; let i = index" [class.text-strong]="rowData.isTotal">
                        <div>
                            <div>{{ rowData.savings | formatUnit: valueFormatter }}</div>
                            @if (rowData.savingsPercentage !== null) {
                                <div
                                    class="text-strong"
                                    [coloredTextColor]="(rowData.savingsPercentage | significantDigits) <= 0 ? 'success' : 'failure'"
                                >
                                    ({{ rowData.savingsPercentage * 100 | significantDigits | localnumber: 1 : 0 : 3 : true }} %)
                                </div>
                            }
                        </div>
                    </ui-cell>
                </ng-container>
                <!-- surfacePerformance Column -->
                <ng-container uiColumnDef="surfacePerformance">
                    <ui-header-cell *uiHeaderCellDef>
                        {{ 'WIDGET.ENERGY_BALANCE_TABLE.SURFACE_PERFORMANCE' | translate }}
                        <help-me class="no-print" [text]="'WIDGET.ENERGY_BALANCE_TABLE.SURFACE_PERFORMANCE_HELPER' | translate" />
                    </ui-header-cell>
                    <ui-cell *uiCellDef="let rowData; let i = index" [class.text-strong]="rowData.isTotal">
                        @if (rowData.ratioByFloorSurface !== null && rowData.ratioByFloorSurface !== undefined) {
                            <span>
                                {{ rowData.ratioByFloorSurface | formatUnit: surfacePerformanceValueFormatter }}
                            </span>
                        }
                    </ui-cell>
                </ng-container>
                <!-- peoplePerformance Column -->
                <ng-container uiColumnDef="peoplePerformance">
                    <ui-header-cell *uiHeaderCellDef>
                        {{ 'WIDGET.ENERGY_BALANCE_TABLE.PEOPLE_PERFORMANCE' | translate }}
                        <help-me class="no-print" [text]="'WIDGET.ENERGY_BALANCE_TABLE.PEOPLE_PERFORMANCE_HELPER' | translate" />
                    </ui-header-cell>
                    <ui-cell *uiCellDef="let rowData; let i = index" [class.text-strong]="rowData.isTotal">
                        @if (rowData.ratioByPeopleCount !== null && rowData.ratioByPeopleCount !== undefined) {
                            <span>
                                {{ rowData.ratioByPeopleCount | formatUnit: peoplePerformanceValueFormatter }}
                            </span>
                        }
                    </ui-cell>
                </ng-container>
                <ui-header-row *uiHeaderRowDef="headers$ | async" />
                <ui-row *uiRowDef="let universeData; columns: headers$ | async" />
            </ui-table>
        }
        @if (isLoading || loadingError || dataSource?.length === 0) {
            <loading-and-error [isLoading]="isLoading" [hasError]="loadingError" [hasNoData]="dataSource?.length === 0" />
        }
    </ui-section-content>
</ui-section>
